<div class="csw-main-widget" role="complementary" aria-label="Booking widget">
  <!-- Widget trigger button with proper button role and keyboard support -->
  <div class="csw-trigger-button" [ngStyle]="triggerIconConfig" role="button" tabindex="0"
       (keydown.enter)="toggleMainWidget()" (keydown.space)="toggleMainWidget()"
       [attr.aria-label]="showMainWidget ? 'Close booking widget' : 'Open booking widget'">
    <div id="csw-trigger-button-overlay" aria-hidden="true"></div>
    @if (!showMainWidget) {
      <div class="csw-trigger-button-open-icon" (click)="toggleMainWidget()" role="img" aria-hidden="true">
        <img [src]="deployUrl + 'assets/images/icons/smartwidget_logo.svg'" alt="Open booking widget">
      </div>
    } @else {
      <div class="csw-trigger-button-close-icon" (click)="resetMainWidget()" role="img" aria-hidden="true">
        <img [src]="deployUrl + 'assets/images/icons/smartwidget_close.svg'" alt="Close booking widget">
      </div>
    }
  </div>
  <!-- Widget trigger button ends -->
  <!-- Main Widget Popup with proper ARIA attributes -->
  @if (showMainWidget) {
    <div class="csw-main-widget-container shadow"
         [ngStyle]="mainWidgetContainerConfig?.styleConfig"
         role="dialog"
         aria-modal="true"
         [attr.aria-label]="title"
         [attr.aria-describedby]="'widget-description'">
      <div class="csw-main-widget-header d-flex justify-content-between align-items-center px-3"
           [ngStyle]="headerConfig"
           role="banner">
        <div class="d-flex align-items-center">
          @if (widgetService?.widgetWorkerData?.avatar && widgetService?.widgetConf?.context?.show_worker_avatar) {
            <div class="pe-2">
              @if (widgetService?.widgetWorkerData.is_resource === 0) {
                <img
                  src="{{workerAvatarBaseUrl}}{{widgetService?.widgetWorkerData?.uuid}}/thumb_{{widgetService?.widgetWorkerData?.avatar}}"
                  class="rounded-circle"
                  [attr.alt]="widgetService?.widgetWorkerData?.name || 'Worker avatar'"
                  width="36" height="36"
                  (error)="onWorkerAvatarError($event)"
                />
              }
            </div>
          }
          <div>
            <div class="title" id="widget-title" role="heading" aria-level="1">{{ title }}</div>
            <div class="description" id="widget-description">{{ description }}</div>
          </div>
        </div>
        <div (click)="resetMainWidget()"
             class="csw-widget-close-button"
             role="button"
             tabindex="0"
             (keydown.enter)="resetMainWidget()"
             (keydown.space)="resetMainWidget()"
             aria-label="Close booking widget">
          <img [src]="deployUrl + 'assets/images/icons/smartwidget_close.svg'" alt="Close" aria-hidden="true">
        </div>
      </div>
      <div class="csw-main-widget-body" role="main">
        <div class="csw-main-widget-body-container"
             [ngClass]="{
               'csw-main-widget-body-fill-container': showFillContainer,
               'csw-main-widget-body-container': !showFillContainer
             }"
             [attr.aria-busy]="!showMainWidgetBody">
          @if (errorConfig.showError) {
            <div class="alert alert-danger" role="alert" aria-live="assertive">
              {{ errorConfig.message }}
            </div>
          }
          @if (showMainWidgetBody) {
            <div>
              <ng-content select="[mainWidgetBody]"></ng-content>
            </div>
          }
        </div>
      </div>
      @if (featuresLoaded() && !isWhitelabel()) {
        <div class="csw-main-widget-footer d-flex justify-content-center align-items-center pb-2" role="contentinfo">
          <div class="footer-logo">
            <img class="footer-logo" [src]="deployUrl + 'assets/images/brand/footer-logo.svg'" alt="Logo" aria-hidden="true" >
          </div>
        </div>
      }
    </div>
  }
  <!-- Main Widget Popup ends -->
  <!-- teaser widget starts -->
  @if (showTeaserWidget) {
    <div class="csw-teaser-widget-container shadow p-3"
         [ngStyle]="teaserConfig?.styleConfig"
         role="complementary"
         aria-label="Booking widget teaser">
      <div (click)="toggleTeaserWidget()"
           class="csw-teaser-close-button d-flex justify-content-center align-items-center"
           role="button"
           tabindex="0"
           (keydown.enter)="toggleTeaserWidget()"
           (keydown.space)="toggleTeaserWidget()"
           aria-label="Close teaser">
        <img [src]="deployUrl + 'assets/images/icons/smartwidget_close.svg'" alt="Close" aria-hidden="true">
      </div>

      <div class="csw-teaser-widget-body"
           (click)="toggleTeaserWidget();toggleMainWidget();"
           role="button"
           tabindex="0"
           (keydown.enter)="toggleTeaserWidget();toggleMainWidget();"
           (keydown.space)="toggleTeaserWidget();toggleMainWidget();"
           aria-label="Open booking widget">
        <div class="d-flex align-items-start">
          @if (widgetService?.widgetWorkerData?.avatar && widgetService?.widgetConf?.context?.show_worker_avatar) {
            <div class="pe-2">
              @if (widgetService?.widgetWorkerData.is_resource === 0) {
                <img
                  src="{{workerAvatarBaseUrl}}{{widgetService?.widgetWorkerData?.uuid}}/thumb_{{widgetService?.widgetWorkerData?.avatar}}"
                  class="rounded-circle"
                  [attr.alt]="widgetService?.widgetWorkerData?.name || 'Worker avatar'"
                  width="36" height="36"
                  (error)="onWorkerAvatarError($event)"
                />
              }
            </div>
          }
          <div>
            @if (triggerData?.isPredefined) {
              <span [innerHTML]="('triggerData?.message' | translate) | calioSafe: 'html'"
                    aria-live="polite">
              </span>
            }
            @if (!triggerData?.isPredefined) {
              <span [innerHTML]="triggerData?.message | calioSafe: 'html'"
                    aria-live="polite">
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  }
  <!-- teaser widget ends -->
</div>

